import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-184c80e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account card custom-inner-card custom-card-padding mb-4" }
const _hoisted_2 = { class: "account-name" }
const _hoisted_3 = { class: "is-size-6-mobile is-size-5-tablet" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("default name")
const _hoisted_5 = {
  key: 0,
  class: "account-backend is-size-6-mobile account-backend"
}
const _hoisted_6 = { class: "is-pulled-right" }
const _hoisted_7 = {
  key: 0,
  class: "is-size-6-mobile is-size-4-tablet account-bal"
}
const _hoisted_8 = {
  key: 1,
  class: "is-size-6-mobile is-size-4-tablet account-bal inactive"
}
const _hoisted_9 = { class: "is-size-6-mobile is-size-5-tablet account-curr" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is-clearfix" }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "sub-accounts"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Acc = _resolveComponent("Acc", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, [
          _renderSlot(_ctx.$slots, "name", {}, () => [
            _hoisted_4
          ], true)
        ])
      ]),
      (_ctx.isMultiCurrency && !_ctx.isSub)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, " - " + _toDisplayString(_ctx.backend), 1))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_6, [
        (_ctx.active)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(parseFloat(_ctx.bal).toLocaleString("fr", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_8, "-.---,--")),
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.curr), 1)
      ]),
      _hoisted_10
    ]),
    (_ctx.subAccounts && _ctx.subAccounts.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subAccounts, (account) => {
            return (_openBlock(), _createBlock(_component_Acc, {
              bal: account.bal,
              curr: account.curr,
              backend: account.backend,
              type: account.type,
              active: account.active,
              isSub: true
            }, {
              name: _withCtx(() => [
                _createTextVNode(_toDisplayString(account.name), 1)
              ]),
              _: 2
            }, 1032, ["bal", "curr", "backend", "type", "active"]))
          }), 256))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}